import { CashRegisterReceiptsProductsDto } from './CashRegisterReceiptsProductsDto';
// import { CommodityWaybillProductDto } from './CommodityWaybillProductDto';
// import { CommodityWaybillInformationDto } from './CommodityWaybillInformationDto';
import {IBaseDocumentDto} from "../IBaseDocumentDto";
import { CashRegisterReceiptsPaymentsDto } from './CashRegisterReceiptsPaymentsDto';

export enum CashRegisterReceiptPaymentType { 
    cash = 0,
    transfer = 1,
    bank = 2,
    vouchers = 3,
    giftCards = 4,
    Other = 5,
}
export interface CreateCashRegisterReceiptsDto extends IBaseDocumentDto {
    baseDocumentAtId?:string;
    customerId?:string;
    warehouseId?:string;
    priceTypeId?:string;
    cashRegisterRetailId?:string;
    createdDate?:Date;
    cashierShiftId?:string;
    products:CashRegisterReceiptsProductsDto[];
    payments:CashRegisterReceiptsPaymentsDto[]
}